import { Dropdown } from "@/atoms"
import { useLogger } from "@/hooks/useLogger"
import { useTranslation } from "@/hooks/useTranslation"
import { MenuDropdown } from "../MenuDropdown"

import styles from "./DropdownSmartSearch.module.scss"

export const DropdownSmartSearch = ({
  open,
  onClick,
  Input,
  id,
  services
}: {
  open?: boolean
  data: any
  onClick: (e: any) => void
  Input: React.ReactNode
  id: string
  services: any
}) => {
  const { t } = useTranslation()
  const { logger } = useLogger()
  const itemProps = { id, t, logger, services, onClick }

  return (
    <Dropdown
      destroyOnHidden
      open={open}
      rootClassName={styles.container}
      trigger={["click"]}
      popupRender={() => <MenuDropdown {...itemProps} />}
    >
      {Input}
    </Dropdown>
  )
}
